import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Redirect, useLocation } from 'react-router-dom';
import { AccountCard, AccountContent, AccountHead, AccountTitle, AccountWrap } from '../account/AccountElements';
import { Button } from '../Button';
import Loading from '../Loading';

/**
 * Componente simples de autenticação com AWS Cognito
 * Mostra botão "Entrar" quando não autenticado
 * Redireciona para Cognito para gerenciar o login
 */
const CognitoAuth = ({
  redirectPath = '/pages/programacao/disponibilidade',
  title = 'Bem vindo',
  subhead = 'Sistema logístico',
  buttonLabel = 'Entrar',
}) => {
  const auth = useAuth();
  const location = useLocation();

  // Mostra loading durante inicialização
  if (auth.isLoading) {
    return <Loading loading={true} />;
  }

  // Se houver erro, mostra mensagem
  if (auth.error) {
    return (
      <AccountWrap>
        <AccountContent>
          <AccountCard>
            <AccountHead>
              <AccountTitle>Erro de Autenticação</AccountTitle>
            </AccountHead>
            <div style={{ marginTop: '20px' }}>
              <p style={{ color: '#dc3545', marginBottom: '20px' }}>
                {auth.error.message || 'Ocorreu um erro ao autenticar'}
              </p>
              <Button variant="primary" onClick={() => auth.signinRedirect()}>
                Tentar Novamente
              </Button>
            </div>
          </AccountCard>
        </AccountContent>
      </AccountWrap>
    );
  }

  // Se já está autenticado, redireciona para a página principal
  if (auth.isAuthenticated) {
    const from = location.state?.from;
    const shouldReturnToRoute = from?.pathname && from.pathname !== '/log_in';
    const redirectTo = shouldReturnToRoute
      ? {
        pathname: from.pathname,
        search: from.search,
        hash: from.hash
      }
      : redirectPath;

    return <Redirect to={redirectTo} />;
  }

  // Se não está autenticado, mostra botão para entrar
  return (
    <AccountWrap>
      <AccountContent>
        <AccountCard>
          <AccountHead>
            <AccountTitle>{title}</AccountTitle>
            <h4 className="subhead">{subhead}</h4>
          </AccountHead>
          <div style={{ marginTop: '20px' }}>
            <Button variant="primary" onClick={() => auth.signinRedirect()} style={{ width: '100%' }}>
              {buttonLabel}
            </Button>
          </div>
        </AccountCard>
      </AccountContent>
    </AccountWrap>
  );
};

export default CognitoAuth;
